
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"m15.5 15.5-2.75-2.75M1.924 5.5h13.152m-6.576 9H2.348a.855.855 0 0 1-.848-.862V3.362c0-.476.38-.862.848-.862h12.304c.468 0 .848.386.848.862V8.75m-1.958 2.02a2.77 2.77 0 1 1-5.542 0 2.77 2.77 0 0 1 5.542 0"}})])
          )
        }
      }
    